// src/components/EventsSection.js

import React, { useState, useEffect } from 'react';
import { db } from '../config/firebaseConfig';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { Link } from 'react-router-dom'; // Yönlendirme için eklendi
import EventCard from './EventCard';

const EventsSection = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Create a query to listen for data changes in Firestore
    const eventsQuery = query(collection(db, 'events'), orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(eventsQuery, (snapshot) => {
      const eventsList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEvents(eventsList);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching events: ", error);
      setLoading(false);
    });

    // Unsubscribe from listener when the component unmounts
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="text-center mt-5">Loading events...</div>;
  }

  return (
    <section className="events-section">
      <div className="container">
        <h2 className="section-title">Events</h2>
        {events.length > 0 ? (
          <div className="events-grid">
            {events.map(event => {
              // Yönlendirme mantığı: Dış link mi yoksa site içi rota mı?
              const isExternalLink = event.eventLink && event.eventLink.startsWith('http');
              const linkUrl = isExternalLink ? event.eventLink : (event.eventLink || `/events/${event.id}`);

              return isExternalLink ? (
                <a 
                  href={linkUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  key={event.id}
                  style={{ textDecoration: 'none', color: 'inherit' }} // Tasarımı bozmaması için
                >
                  <EventCard event={event} />
                </a>
              ) : (
                <Link 
                  to={linkUrl} 
                  key={event.id} 
                  style={{ textDecoration: 'none', color: 'inherit' }} // Tasarımı bozmaması için
                >
                  <EventCard event={event} />
                </Link>
              );
            })}
          </div>
        ) : (
          <p className="text-center">No events found yet.</p>
        )}
      </div>
    </section>
  );
};

export default EventsSection;